import React from "react";
import Link from "gatsby-link";
import styled from "styled-components";
import { compose, withState, withHandlers } from "recompose";
import Logo from "./Logo";
import MenuIcon from "./MenuIcon";
import NavMenu from "./NavMenu";
import { getThemeColor } from "../utils";

const NavBar = styled.div`
  position: relative;
  background-color: ${getThemeColor}};
  display: flex;
  justify-content: center;
  padding: 2rem 5rem;

  ${props => props.theme.media.mobile`
    padding: 1rem 1.5rem;
  `};
`;
const Inner = styled.div`
  max-width: 72rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const enhance = compose(
  withState("isVisible", "toggleVis", false),
  withHandlers({
    toggleMenuVisibility: props => event => {
      props.toggleVis(!props.isVisible);
    }
  })
);

export default enhance(
  ({
    color = "dark",
    background = "transparent",
    isVisible,
    toggleMenuVisibility
  }) =>
    <NavBar color={background}>
      <Inner>
        <Link to="/">
          <Logo color={color} />
        </Link>
        <MenuIcon color={color} toggleMenuVisibility={toggleMenuVisibility} />
        <NavMenu
          isVisible={isVisible}
          toggleMenuVisibility={toggleMenuVisibility}
        />
      </Inner>
    </NavBar>
);



// WEBPACK FOOTER //
// ./src/components/NavBar.js